import React from "react";
import { useRouter } from "next/router";
import { Hooks } from "@xt/xtbase";
import styles from "./securitySubPageBack.module.scss";

const { useTranslation } = Hooks;

const BackChevron: React.FC<{ className?: string }> = ({ className }) => (
  <svg className={className} width="14" height="14" viewBox="0 0 12 12" fill="none" aria-hidden>
    <path
      d="M7.5 3L4.5 6L7.5 9"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const SecuritySubPageBack: React.FC = () => {
  const t = useTranslation();
  const router = useRouter();

  const handleBack = () => {
    router.push("/accounts/user/security-center");
  };

  return (
    <button type="button" className={styles.back} onClick={handleBack} aria-label={t("app.back") || "Back"}>
      <BackChevron className={styles.arrow} />
      <span className={styles.text}>{t("app.back")}</span>
    </button>
  );
};

export default SecuritySubPageBack;
